import React, { useState, useEffect } from 'react';
import { Column } from '@ant-design/charts';

// const colors = ['#fab74a', '#f9747c', '#36b4ff', '#51826d'];

// const colors = ['#FF747C', '#FFB74A', '#60FAFF', '#54A6FF'];
const colors = ['#2CC65D', '#E29B2F', '#60FAFF'];

const ResponseTimePercentHistogram = (props) => {
    var data = [
        {
            name: 'Earliest',
            value: 0,
        },
        {
            name: 'Latest',
            value: 0,
        },
        {
            name: 'Average',
            value: 0,
        },

    ];
    var config = {
        data: props && props.datainGraph && props.datainGraph.length > 0 ? props.datainGraph : data,
        // data: data,
        xField: 'name',
        yField: 'value',
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
            },
        },
        meta: {
            value: { alias: 'ak' },
            name: { alias: 'ss' },
        },
        minColumnWidth: 90,
        maxColumnWidth: 90,
        // yAxis: {
        //   // format y axis label style
        //   label: {
        //     formatter: (v) => {
        //       return v;
        //       // return v + 'k';
        //     },
        //     style: {
        //       fill: '#000',
        //     },
        //   },
        // },
        seriesField: 'name',
        color: colors,
        legend: {
            layout: 'horizontal',
            position: 'top-right'
        },
        appendPadding: 30,
        // dodgePadding: 2,
        intervalPadding: 80,
        interactions: [{ type: 'element-active' }],
        //isPercent: false,
        // isGroup: true,
        // isStack: true,
        // label: {
        //   position: 'middle',
        //   content: function content(item) {
        //     // return item.value.toFixed(2);
        //     return '';
        //   }
        // },
    };
    return <Column {...config} />;
};

export default ResponseTimePercentHistogram;